import * as React from 'react';
import { useSelector } from 'react-redux';
import { FormControlLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useTheme } from '../../../../theme';
import { getOrder } from '../../../store/order/selectors';
import { usePassengerConsents } from './PassengersConsents.hook';
import { useCustomerInfo } from '../FormBlockSlot/hooks';
import Checkbox from '../../../../BaseComponents/Checkbox';
import Tooltip from '../../../../BaseComponents/Tooltip';
import FareConditionsModal from '../../../../InfoLinksLabel/components/FareConditionsModal';
import { initI18n } from '../../../../utils';
initI18n('PassengersConsents');
const PassengersConsents = ({ login, customer, isAuthorized }) => {
    const { t } = useTranslation('PassengersConsents');
    const { PassengersConsents: theme } = useTheme('Checkout');
    const order = useSelector(getOrder);
    const orderId = order.id;
    const flightId = order.flight.id;
    const segmentId = order.flight.segments[0].segment.id;
    const { showSubscribedCheckbox } = useCustomerInfo({ login, customer, isAuthorized });
    const model = usePassengerConsents({ showSubscribedCheckbox });
    if (!model.isVisible) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: theme.container, onClick: model.onClick },
            React.createElement(FormControlLabel, { classes: {
                    root: theme.label,
                    label: cn(theme.label, theme.label_main)
                }, label: React.createElement("span", { dangerouslySetInnerHTML: { __html: t('Consents_Main') } }), control: React.createElement(Tooltip, { title: model.termsField.meta.error, open: model.termsField.meta.submitFailed && !model.termsField.input.value },
                    React.createElement(Checkbox, { checked: model.isChecked, indeterminate: model.isIndeterminate })), onChange: model.onToggleAll, ref: model.checkboxRef }),
            model.isVisible && (React.createElement("div", { className: theme.conditions }, model.conditionKeys.map(condition => (React.createElement(FormControlLabel, { key: condition.key, classes: { root: theme.label, label: theme.label }, control: React.createElement(Checkbox, { checked: model.selectedKeys.includes(condition.key), onChange: model.onToggle(condition.key) }), label: React.createElement("span", { dangerouslySetInnerHTML: { __html: t(condition.key) } }) })))))),
        React.createElement(FareConditionsModal, { orderId: orderId, flightId: flightId, segmentId: segmentId, isOpen: model.isOpenTermsOfTariff, onClose: model.onCloseTermsOfTariff })));
};
export default PassengersConsents;
